import Vue from 'vue'
import ajax from '../utils/ajax'

export class UserClass extends Vue {
    constructor() {
        super();
        this._user = void(0);
        Vue.util.defineReactive(this, 'user', this._user);
    }

    async refresh() {
        this.setUser((await ajax.get('/api/users/current')) || null);
    }

    setUser(user) {
        let changed = JSON.stringify(user) !== JSON.stringify(this._user);
        this.user = JSON.parse(JSON.stringify(user));
        if (changed) {
            this._user = user;
            this.$emit("changed", this.user);
            if (!user) {
                window.location.href = "/login.html";
            }
        }
    }

    async logout() {
        await ajax.delete('/api/sessions/current');
        this.setUser(null);
    }
}

export default new UserClass();
